import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FetchPolicy } from '@apollo/client/core';

import { AppConfigService } from 'src/app/services/app.config.service';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { BehaviorSubject,  Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GraphqlService } from '../graphql.service';


@Injectable({
  providedIn: 'root'
})
export class OpenPoService extends GraphqlService {
  public nsURL:string;
  constructor(
    apolloProvider: Apollo,
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    super(apolloProvider);
    this.nsURL = this.appConfigService.get('nsURL');
    
  }
  errorHandler(error: HttpErrorResponse): Observable<string> {
    return throwError(
      error.error ||
      error.message ||
      "Server Error"
    );
  }
  executeQuery(query:any, variables?: any, fetchPolicy: FetchPolicy = 'network-only'): Observable<any> {
    return this.legacyApollo.query({
      query,
      variables,
      fetchPolicy: fetchPolicy
    });
  }

  executeMutation(mutation:any, variables?: any): Observable<any> {
    return this.legacyApollo.mutate({
      mutation,
      variables
    });
  }

  executeVpMutation(mutation:any, variables?: any): Observable<any> {
    return this.apollo.mutate({
      mutation,
      variables
    });
  }
  sendEmail(reqBody:any) {
    return this.http.post(this.nsURL+'/sendmail', reqBody)
}
  getUserList():Observable<any>{
    const query = gql`query userList {
      userList {
        udEmail
      }
    }`
      return this.vpmApollo.query({
        query,
        fetchPolicy: 'cache-first',
        variables: {}
      }).pipe(
        map(
          response => {
            return response;
          }
        )
      )
  }
  getAzureUserId(email:any):Observable<any>{
    const query = gql`query GetAzureUserId($email: String)  {
      getAzureUserId (email: $email) {
        udEmail
        udRole
        disclaimer
        userRoleDtls {
          roleName
        }
        vendorDetails {
          email1
          email2
          email3
          email4
          email5
          email6
          email7
          email8
          email9
          email10
          vendorCode
          vendorCountry
          vendorId
          vendorLocation
          vendorName
          vendorPan
        }
        udVendorCode
      }
    }`
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'network-only',
      variables: {email: email}
    }).pipe(
      map(
        response => {
          return response;
        }
      )
    )
  }

  

  getRoleList(req:any, offset:any, limit:any): Observable<any> {
    const query = gql`query GetRoleList($filter: RoleInput!, $offset: Int!, $limit: Int!) {
        getRoleList(filter: $filter, offset: $offset, limit: $limit) {
          count
          rows {
            roleId
            roleName
            roleDescription
            roleLastModifiedBy
            roleLastModifiedDate
            roleTemp2
          }
        }
      }`
    // return this.observableToPromise(this.vpmApollo.query({
    //   query,
    //   fetchPolicy: 'network-only',
    //   variables: { filter: req, offset: offset, limit: limit }
    // }), 'getRoleList');

    return this.vpmApollo.query({
      query,
      fetchPolicy: 'cache-first',
      variables: { filter: req, offset: offset, limit: limit }
    }).pipe(
      map(
        response => {
          return response;
        }
      )
    )
  }

  createUser(data:any): Observable<any> {
    const mutation = gql`mutation CreateUser($data: CreateEditUserInput) {
        createUser(data: $data)
      }`;
    return this.vpmApollo.mutate({
      mutation,
      fetchPolicy: 'network-only',
      variables: { data: data }
    });
  }

  createOrUpdateUser(data:any): Observable<any> {
    const mutation = gql`mutation CreateOrUpdateUser($data: createUpdateUserRoleInput) {
      createOrUpdateUser(data: $data)
      }`;
    return this.vpmApollo.mutate({
      mutation,
      fetchPolicy: 'network-only',
      variables: { data: data }
    });
  }

  
  updateDisclaimer(data:any) {
    const mutation = gql`mutation UpdateDisclaimer($data: DisclaimerUpdateInput) {
      updateDisclaimer(data: $data)
      }`;
    return this.vpmApollo.mutate({
      mutation,
      fetchPolicy: 'network-only',
      variables: { data }
    });
  }

  GetUserStatusByEmail(userEmail: string) {
    const query = gql`
      query GetUserStatusByEmail($userEmail: String) {
        getUserStatusByEmail(userEmail: $userEmail) {
          udStatus
        }
      }`
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'network-only',
      variables: {
        userEmail
      }
    });
  }

  getAllUserDetailByEmail(filter:any): Observable<any> {
    const query = gql`query GetAllUserDetailByEmail($filter: userDetailRequest) {
      getAllUserDetailByEmail(filter: $filter) {
        userDetail {
          udUserid
          udUserName
          udFirstName
          udMiddleName
          udLastName
          udVendorCode
          udRole
          vendorSubCategory
          udStatus
          udReportingto
          udEmail
          udState
          udCountry
          udContactnumber
          udAddress
          udPincode
          udSapId
          udCreatedby
        }
        UserRole {
          udUserid
          udRoleid
          MurRoleMtr {
            roleName
          }
        }
        userVendorCode {
          vendorCode
        }
      }
    }`
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'network-only',
      variables: { filter }
    }).pipe(
      map((response: any) => response.data.getAllUserDetailByEmail)
    )
  }

  InviteStatusUpdate(email: string) {
    const query = gql`
      query Query($email: String) {
        InviteStatusUpdate(email: $email)
      }
    `;
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'network-only',
      variables: {
        email
      }
    });
  }

  GetPanByEmail(email: string) {
    const query = gql`
      query GetPanByEmail($email: String) {
        getPanByEmail(email: $email) {
          vendorPan
        }
      }`
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'network-only',
      variables: {
        email
      }
    });
  }

    isEmailAvailable(userEmail: string) {// this service is to check the logged-in email is present in VOB user details table or not.
    const query = gql`
			query isEmailAvailable($userEmail: String!) {
				isEmailAvailable(userEmail: $userEmail)
			}
		`;
    return this.vobApolloBase.query({
      query,
      variables: {
        userEmail,
      }
    });
  }

  getConfigByType(configType: string) {
    const query = gql`
      query GetConfigByType($configType: String) {
        getConfigByType(configType: $configType) {
          value1
          value2
          value3
          value4
        }
      }
    `;
    return this.vpmApollo.query({
      query,
      fetchPolicy: 'cache-first',
      variables: { configType }
    }).pipe(
      map(
        response => {
          return response;
        }
      )
    )
  }

  isUserAvailableAndHasVendorCodeInSOB(userEmail: string) {// this service is to check the logged-in email is present in VOB user details table with vendorcode or not.
    const query = gql`
			query IsUserAvailableAndHasVendorCode($userEmail: String!) {
				isUserAvailableAndHasVendorCode(userEmail: $userEmail)
			}
		`;
    return this.vobApolloBase.query({
      query,
      variables: {
        userEmail,
      }
    });
  }

  isDisclaimerAgreedByTheUserInSOB(userEmail: string) {// this service is to check the logged-in email is present in VOB user details table with vendorcode or not.
    const query = gql`
			query IsDisclaimerAgreedByTheUser($userEmail: String!) {
				isDisclaimerAgreedByTheUser(userEmail: $userEmail)
			}
		`;
    return this.vobApolloBase.query({
      query,
      variables: {
        userEmail,
      }
    });
  }
}
